export { default } from "~/components/ui/TopSales"

export function LoadingFallback() {
  return <div className='w-full min-h-[600px] bg-base-200/30 animate-pulse' />
}
